import React from 'react';

export default function SettingsProfilePage() {
  return (
    <main style={{ fontFamily: 'Inter, sans-serif', padding: '24px' }}>
      <h1>Hello World</h1>
      <p>Settings profile shell (Phase 1E).</p>
    </main>
  );
}
